export default __webpack_public_path__ + "static/media/products-setting-image-homepage.2f431eb8.png";